import { FormControl, FormHelperText } from "@mui/material";
import React from "react";
import { OrderTextFieldSmall } from "../input/styled/orders";
import { useAppSelector } from "../../../redux/store";
import { MessageSections } from "../message/message";
import { BarekamSelect } from "../select/select";
import { BarekamMenuItem, SelectedBarekamMenuItem } from "../select/styled/orders";
import { InputWithSelectContainer } from "./styled";
import { getMessage } from "../../shared/helper-functions";

const BarekamInputWithSelect = (
    {
        selectedType,
        selectedValue,
        types,
        onValueChange,
        onTypeChange,
        idFieldName,
        required,
        error,
        errorMessage,
        isReadonly,
        freezeSelect,
        placeholderKey,
        id,
        ...props
    }: BarekamInputWithSelectProps) => {


    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    const handleTypeChange = (typeId: number) => {
        const type = types.find(type => type[idFieldName] === typeId);

        onTypeChange(type);
    }

    const handleValueChange = (value: any) => {
        if (/^(0|[1-9]\d*)(\.\d*)?$|^(\.\d+)?$/.test(value)) {
            onValueChange(value);
        }
    }

    const placeholder = getMessage(placeholderKey, MessageSections.MAIN, messageCache, languageId);

    return (
        <FormControl error={error} fullWidth>
            <InputWithSelectContainer>
                <OrderTextFieldSmall
                    id={id}
                    {...props}
                    label={placeholder}
                    value={selectedValue || ''}
                    onChange={(event) => handleValueChange(event.target.value)}
                    type='text'
                    // inputProps={{ min: 0 }}
                    disabled={isReadonly}
                    error={error}
                    required={required} />

                {isReadonly || freezeSelect
                    ? <></>
                    : <BarekamSelect
                        variant={'outlined'}
                        value={selectedType}
                        color={'primary'}
                        type={"standard"}>
                        {
                            types.map(type =>
                                selectedType === type[idFieldName]
                                    ?
                                    <SelectedBarekamMenuItem value={type[idFieldName]}
                                        key={type[idFieldName]}
                                        onClick={() => handleTypeChange(type[idFieldName])}>
                                        {type.name[languageId]}
                                    </SelectedBarekamMenuItem>
                                    :
                                    <BarekamMenuItem value={type[idFieldName]}
                                        key={type[idFieldName]}
                                        onClick={() => handleTypeChange(type[idFieldName])}>
                                        {type.name[languageId]}
                                    </BarekamMenuItem>
                            )
                        }
                    </BarekamSelect>
                }
            </InputWithSelectContainer>

            {error ? <FormHelperText>{errorMessage}</FormHelperText> : <></>}
        </FormControl>
    );
};

export default BarekamInputWithSelect;

interface BarekamInputWithSelectProps {
    selectedValue: number | null,
    selectedType: number | null,

    types: any[]; // TODO: add types

    onTypeChange: (value: number) => void;
    onValueChange: (value: number) => void;

    id?: string;
    idFieldName: string;
    placeholderKey: string;
    required?: boolean;
    isReadonly?: boolean;
    freezeSelect?: boolean;

    error?: boolean;
    errorMessage?: string;
}
